<template>
  <generic-modal
    size="large"
    :title="$t('student')"
    icon="user tie"
    image="/images/icons/student.png"
    v-bind:scrolling="false"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
  >
    <div class="description">
      <div class="ui form" ref="form">
        <h4 class="ui dividing header">{{ $t("personal information") }}</h4>
        <div class="fields">
          <div class="three column wide field">
            <label for>{{ $t("student id card") }}</label>
            <div class="ui action input">
              <input
                type="text"
                name="student_id"
                v-model="setup.student_id_card"
              />
              <button
                class="ui teal right icon button"
                v-bind:class="{ disabled: student_uuid }"
                :data-tooltip="$t('generate')"
                @click="generate_student_id_card"
              >
                <i class="lightning icon"></i>
              </button>
            </div>
          </div>
          <div class="five column wide field">
            <label for>{{ $t("name") }}</label>
            <input type="text" name="name" v-model="setup.name" />
          </div>
          <div class="four column wide field">
            <label for>{{ $t("birthdate") }}</label>
            <div class="ui calendar" ref="birthdate">
              <div class="ui input left icon">
                <i class="calendar icon"></i>
                <input type="text" name="birthdate" v-model="setup.birthdate" />
              </div>
            </div>
          </div>
          <div class="four column wide field">
            <label for>{{ $t("dpi") }}</label>
            <input type="text" name="dpi" v-model="setup.dpi" />
          </div>
        </div>
        <div class="fields">
          <div class="four column wide field">
            <label for>{{ $t("gender") }}</label>
            <div class="ui selection dropdown" ref="gender_dropdown">
              <input type="hidden" name="gender" />
              <i class="dropdown icon"></i>
              <div class="default text"></div>
              <div class="menu">
                <div class="item" data-value="m">
                  <i class="mars icon"></i>
                  {{ $t("male") }}
                </div>
                <div class="item" data-value="f">
                  <i class="venus icon"></i>
                  {{ $t("female") }}
                </div>
                <div class="item" data-value="u">
                  <i class="neuter icon"></i>
                  {{ $t("undefined") }}
                </div>
              </div>
            </div>
          </div>
          <div class="four column wide field">
            <label for>{{ $t("civil status") }}</label>
            <div class="ui selection dropdown" ref="civil_status_dropdown">
              <input type="hidden" name="civil_status" />
              <i class="dropdown icon"></i>
              <div class="default text"></div>
              <div class="menu">
                <div class="item" data-value="s">
                  <i class="male icon"></i>
                  {{ $t("single") }}
                </div>
                <div class="item" data-value="m">
                  <i class="restroom icon"></i>
                  {{ $t("married") }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <h4 class="ui dividing header">{{ $t("contact vias") }}</h4>
        <div class="fields">
          <div class="three column wide field">
            <label for>{{ $t("residential phone") }}</label>
            <input
              type="text"
              name="residential_phone"
              v-model="setup.residential_phone"
            />
          </div>
          <div class="three column wide field">
            <label for>{{ $t("cellphone") }}</label>
            <input type="text" name="cellphone" v-model="setup.cellphone" />
          </div>
          <div class="five column wide field">
            <label for>{{ $t("email") }}</label>
            <input type="text" name="email" v-model="setup.email" />
          </div>
          <div class="five column wide field">
            <label for>{{ $t("residential address") }}</label>
            <input
              type="text"
              name="residential_address"
              v-model="setup.residential_address"
            />
          </div>
        </div>
        <div class="fields">
          <div class="eight column wide field">
            <label for>{{ $t("work address") }}</label>
            <input
              type="text"
              name="work_address"
              v-model="setup.work_address"
            />
          </div>
          <div class="eight column wide field">
            <label for>{{ $t("workplace") }}</label>
            <input type="text" name="workplace" v-model="setup.workplace" />
          </div>
        </div>

        <h4 class="ui dividing header">{{ $t("academic background") }}</h4>
        <div class="two fields">
          <div class="field">
            <label for>{{ $t("stablishment name") }}</label>
            <input
              type="text"
              name="stablishment_name"
              v-model="setup.stablishment_name"
            />
          </div>
          <div class="field">
            <label for>{{ $t("degree title") }}</label>
            <input
              type="text"
              name="degree_title"
              v-model="setup.degree_title"
            />
          </div>
        </div>
        <div class="ui error message"></div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import { local_api, stringify } from "@/utils";
import GenericModal from "@/components/GenericModal";
// import GenericContainer from "@/components/GenericContainer";

export default {
  name: "StudenModal",
  components: {
    "generic-modal": GenericModal,
    // "generic-container": GenericContainer
  },
  computed: {},
  props: { student_uuid: String },
  data() {
    return {
      setup: {
        student_id_card: "",
        name: "",
        dpi: "",
        birthdate: "",
        residential_phone: "",
        cellphone: "",
        email: "",
        residential_address: "",
        gender: "",
        civil_status: "",
        workplace: "",
        work_address: "",
        stablishment_name: "",
        degree_title: "",
      },
    };
  },
  methods: {
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        let isValid = window.jQuery(vm.$refs.form).form("validate form");

        if (!isValid) reject();
        else {
          local_api(vm, "post", "/student/do-save", {
            i: vm.student_uuid || undefined,
            s: vm.setup,
          })
            .then((student) => {
              vm.$emit("succedded", student);
              resolve();
            })
            .catch((err) => {
              window.jQuery(vm.$refs.form).form("add errors", [err]);
              reject(err);
            });
        }
      });
    },
    destroy() {
      this.$emit("destroy");
      this.$destroy();
    },
    generate_student_id_card() {
      let vm = this;
      local_api(vm, "post", "/student/do-generate-id", {})
        .then((r) => {
          this.setup.student_id_card = r;
          // this.setup.student_id_card = Math.floor(
          //   1000000 + Math.random() * 9000000,
          // );
        })
        .catch((err) => {
          vm.$alertify.error(err);
        });
    },
  },
  mounted() {
    let vm = this;

    window.jQuery(vm.$refs.form).form({
      fields: {
        student_id: ["empty"],
        name: ["empty"],
        birthdate: ["empty"],
        email: ["empty", "email"],
        dpi: ["empty", "exactLength[13]"],
        residential_phone: ["exactLength[8]"],
        cellphone: ["exactLength[8]"],
      },
    });

    window.jQuery(vm.$refs.birthdate).calendar({
      type: "date",
      onChange(value) {
        vm.setup.birthdate = value;
      },
    });

    window.jQuery(vm.$refs.gender_dropdown).dropdown({
      onChange(value) {
        vm.setup.gender = value;
      },
    });
    window.jQuery(vm.$refs.civil_status_dropdown).dropdown({
      onChange(value) {
        vm.setup.civil_status = value;
      },
    });
  },
  watch: {},
  updated: function() {},
  created() {
    let vm = this;
    if (vm.student_uuid) {
      local_api(vm, "post", "/student/do-get", {
        u: vm.student_uuid,
      })
        .then((student) => {
          vm.setup = student.setup;

          if (vm.setup.gender)
            window
              .jQuery(vm.$refs.gender_dropdown)
              .dropdown("set selected", vm.setup.gender);
          if (vm.setup.civil_status)
            window
              .jQuery(vm.$refs.civil_status_dropdown)
              .dropdown("set selected", vm.setup.civil_status);
        })
        .catch((err) => {
          vm.$alertify.error(stringify(err));
        });
    }
  },
};
</script>
